var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 101,
    viewBox: "0 0 185 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184.2,
    height: 101,
    fill: "#363540"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111 53.5C111 57.7523 109.739 61.9091 107.377 65.4448C105.014 68.9804 101.656 71.7361 97.7277 73.3634C93.7991 74.9907 89.4762 75.4165 85.3056 74.5869C81.135 73.7573 77.304 71.7096 74.2972 68.7028C71.2904 65.696 69.2427 61.865 68.4131 57.6944C67.5835 53.5238 68.0093 49.2009 69.6366 45.2723C71.2639 41.3437 74.0196 37.9859 77.5552 35.6234C81.0909 33.261 85.2477 32 89.5 32V53.5H111Z",
    fill: "#63616B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.5 27C96.4547 27 99.3806 27.582 102.11 28.7127C104.84 29.8434 107.321 31.5008 109.41 33.5901C111.499 35.6794 113.157 38.1598 114.287 40.8896C115.418 43.6195 116 46.5453 116 49.5L93.5 49.5V27Z",
    fill: "#7B7986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPreview);
export default __webpack_public_path__ + "static/media/projectPreview.40ffa5105b6d076e4b3e1ea340d4a6bd.svg";
export { ForwardRef as ReactComponent };